import { Component, OnInit, inject, input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ToastMessageService } from '../../../shared/modules/toast-message/toast-message.service';
import { ValidationPatterns } from 'src/app/core/helpers/validation-patterns';
import { ModalRef } from 'src/app/core/modal/modal-ref';
import { FormsErrorHandlerService } from 'src/app/core/services/forms-error-handler.service';
import { PlatformGraphQlService } from 'src/app/core/services/graphql/platform-graphql.service';
import { ApolloError } from '@apollo/client/errors';
import { TranslatePipe } from '../../../services/translation/translate.pipe';
import { BtnComponent } from '../btn/btn.component';
import { FormInputComponent } from '../form-controls/form-input/form-input.component';

/**
 * Available instruction types
 */
export enum InstructionType {
  RESET = 'reset_password',
  UNLOCK = 'unlock',
  CONFIRMATION = 'confirmation',
}

@Component({
    selector: 'app-restoration-instruction',
    templateUrl: './restoration-instruction.component.html',
    styleUrls: ['./restoration-instruction.component.scss'],
    imports: [ReactiveFormsModule, FormInputComponent, BtnComponent, TranslatePipe]
})
export class RestorationInstructionComponent implements OnInit {

  private _fb = inject(FormBuilder);
  private _formErrors = inject(FormsErrorHandlerService);
  private _toastMessage = inject(ToastMessageService);
  private _platformApi = inject(PlatformGraphQlService);

  /**
   * Data for each instruction type
   */
  public instructionTypeData = {
    [InstructionType.RESET]: {
      title: 't.forgot-pass',
      description: 't.fill-in-your-email-addres',
      buttonLabel: 'btn.reset-pass',
      submitFn: this._platformApi.resetUsersPassword.bind(this._platformApi)
    },
    // [InstructionType.UNLOCK]: {
    //   title: 'btn.resend-unlock-i',
    //   description: 't.if-your-account-has-been-locked',
    //   buttonLabel: 'btn.resend-unlock-i',
    //   submitFn: this._platformApi.resetUsersPassword.bind(this._platformApi)
    // },
    // [InstructionType.CONFIRMATION]: {
    //   title: 'btn.resend-conf-i',
    //   description: '',
    //   buttonLabel: 'btn.resend-conf-i',
    //   submitFn: this._platformApi.resetUsersPassword.bind(this._platformApi)
    // },
  };

  get Type() {
    return InstructionType;
  }

  /**
   * Is form loading
   */
  public loading: boolean;

  /**
   * Active instruction type type
   */
  public currentType: InstructionType = InstructionType.RESET;

  /**
   * Request instruction form
   */
  public form: FormGroup = this._fb.group({
    email: [null, [Validators.required, Validators.pattern(ValidationPatterns.email)]],
  });

  /**
   * Form errors
   */
  public errors: any = {};

  readonly modal = input<ModalRef>(null);

  ngOnInit() {

  }

  /**
   * Form submit handler
   */
  submit() {
    this.errors = this._formErrors.applyFormErrors(this.form, null, true);

    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    this.instructionTypeData[this.currentType].submitFn(this.form.value).pipe(
      tap(() => {
        this._toastMessage.success('t.instructions-sent-to-your-email');
        const modal = this.modal();
        if (modal) {
          modal.close();
        }
      }),
      catchError((error: ApolloError) => {
        // this.errors = this._formErrors.applyFormErrors(this.form, error.error);
        this._toastMessage.error(error?.message);
        this._toastMessage.error('t.check-your-data-again');
        return of(error);
      })
    ).subscribe(() => {
      this.loading = false;
    });
  }

  public changeType(type: InstructionType) {
    this.currentType = type;
    this.form.reset({email: ''});
  }

}
